import PageviewIcon from '@material-ui/icons/Pageview';
import AppButton from 'components/atoms/Button';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import NavigationConfig from 'navigation/config';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { requiredLogin } from '../../../../middlewares';
import { TranslationKey } from '../configuration';
import useStyles from '../styles';

const NewsButton = () => {
  const classes = useStyles({});
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <AppButton
      variant="text"
      color="inherit"
      startIcon={<PageviewIcon />}
      text={
        <TranslatedTextV2
          translationKey={`${TranslationKey}.news`}
          defaultText="News"
        />
      }
      onClick={() => history.push(NavigationConfig.showNewsPage().path)}
    />
  );
};

export default NewsButton;
